import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import "./signupPage.css";
import { createAuthUser } from "../../db/firebaseMethods";
import AppContext from "../../AppContext";
import { Navigate, Link } from "react-router-dom";
import LoadingBlock from "../../components/organisms/loadingBlock/loadingBlock";

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    color: "white",
    "& fieldset":             { borderColor: "rgba(255,255,255,0.3)" },
    "&:hover fieldset":       { borderColor: "rgba(255,255,255,0.65)" },
    "&.Mui-focused fieldset": { borderColor: "white", borderWidth: 2 },
  },
  "& input::placeholder": { color: "rgba(255,255,255,0.35)" },
};

const AuthField = ({ label, ...props }) => (
  <Box>
    <Box
      component="span"
      sx={{
        display: "block",
        textAlign: "left",
        color: "rgba(255,255,255,0.75)",
        fontSize: "0.8rem",
        fontWeight: 600,
        letterSpacing: "0.6px",
        mb: 0.5,
        textTransform: "uppercase",
      }}
    >
      {label}
    </Box>
    <TextField fullWidth variant="outlined" size="small" sx={fieldSx} {...props} />
  </Box>
);

export default function SignUpPage() {
  const [isLoading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isWpChecked, setIsWpChecked] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { setCentralState, user, activeSeason } = React.useContext(AppContext);
  if (user) return <Navigate replace to="/profile" />;

  const addUser = async (email, pass) => {
    if (!activeSeason) {
      alert("Kayıt süreci sona ermiştir, bir sonraki sezonda görüşmek üzere.");
      return;
    }
    setLoading(true);
    const res = await createAuthUser(email, pass, activeSeason.id);
    if (res?.uid) {
      setCentralState({
        user: res,
      });
    }
    setLoading(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    // eslint-disable-next-line no-console
    let values = {
      email: "",
      password: "",
      password2: "",
      // firstName:"",
      // lastName:"",
      // birthYear:""
    };

    Object.keys(values).forEach((k) => {
      values[k] = data.get(k)?.trim();
    });

    if (!isChecked) {
      alert(
        "Kayıt olabilmek için SMS, e-posta ve benzeri iletişim kanalları üzerinden bilgilendirme ve duyuru gönderilmesini onaylamalısınız."
      );
      return;
    }
    if (!isWpChecked) {
      alert("Kongre ile ilgili WhatsApp kanalına katılımı onaylamalısınız.");
      return;
    }
    if (values.password.length < 6)
      alert("Şifre en az 6 karakter uzunluğunda olmalıdır.");
    else if (values.password !== values.password2) {
      alert("Girdiğiniz şifreler uyuşmuyor! Tekrar giriniz.");
    } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(values.email))
      alert("Lütfen geçerli bir e-posta adresi yazınız.");
    else {
      addUser(values.email, values.password);
    }
  };
  return (
    <Container component="main" maxWidth="xs">
      {isLoading && <LoadingBlock />}
      <CssBaseline />
      <Box
        sx={{
          marginTop: 4,
          marginBottom: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div className="auth-title">KAYIT OL</div>
        <span className="auth-title-accent" />

        <div className="auth-card" style={{ width: "100%" }}>
          <Box component="form" noValidate onSubmit={handleSubmit}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <AuthField
                label="E-Posta"
                id="email"
                name="email"
                autoComplete="email"
                placeholder="ornek@mail.com"
              />
              <AuthField
                label="Şifre"
                type="password"
                id="password"
                name="password"
                placeholder="En az 6 karakter"
              />
              <AuthField
                label="Şifre Tekrar"
                type="password"
                id="password2"
                name="password2"
                placeholder="Şifrenizi tekrar girin"
              />

              <label className="auth-checkbox-label">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
                <span>
                  TZV organizasyonları kapsamında, tarafıma SMS, e-posta ve
                  benzeri iletişim kanalları üzerinden bilgilendirme ve duyuru
                  gönderilmesini kabul ediyorum.
                </span>
              </label>

              <label className="auth-checkbox-label">
                <input
                  type="checkbox"
                  checked={isWpChecked}
                  onChange={(e) => setIsWpChecked(e.target.checked)}
                />
                <span>
                  Kongre ile ilgili tüm bilgilendirme ve duyurular Türkiye
                  Zeka Vakfı'nın WhatsApp kanalı üzerinden yapılacaktır.
                  Gelişmelerden haberdar olmak için{" "}
                  <a
                    href="https://whatsapp.com/channel/0029Vb66wLJDp2QDYnSnqm0c"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#25D366", textDecoration: "underline" }}
                  >
                    buraya tıklayarak
                  </a>{" "}
                  kanala katılabilirsiniz.
                </span>
              </label>
            </Box>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                background: "linear-gradient(135deg, #ec398b 0%, #8b31c7 100%)",
                borderRadius: "12px",
                fontWeight: 700,
                fontSize: "1rem",
                letterSpacing: "1.5px",
                padding: "11px 0",
                boxShadow: "0 4px 20px rgba(236, 57, 139, 0.35)",
                "&:hover": {
                  background: "linear-gradient(135deg, #d42d7a 0%, #7a2ab3 100%)",
                  boxShadow: "0 6px 24px rgba(236, 57, 139, 0.5)",
                  transform: "translateY(-1px)",
                },
                transition: "all 0.2s ease",
              }}
            >
              KAYIT OL
            </Button>

            <Box sx={{ textAlign: "center", mt: 0.5 }}>
              <Link to="/login" className="auth-link">
                Hesabınız var mı? Giriş yapın
              </Link>
            </Box>
          </Box>
        </div>
      </Box>
    </Container>
  );
}
